module.exports = __webpack_public_path__ + "sign-on-widget-spinner.eea28db2b98f4df40b5608a54d0b9131.gif";